/* eslint-disable no-console */
<template>
  <div class="edit_box">
    <div class="line1">
      <div class="line1_left">{{ title }}</div>
    </div>
    <div class="form_wrap">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="140px"
        :disabled="parentData.isDetail"
      >
        <div class="mode_box" :class="{ pitch_on: !!form.idIsup }">
          <div class="card_info">身份证信息</div>

          <!-- 必填 -->
          <el-row style="padding-right:80px;">
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input v-model="form.name" placeholder="姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生年月" prop="birthDate">
                <el-input
                  v-model="form.birthDate"
                  placeholder="请输入出生年月"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别" prop="sex">
                <el-select
                  v-model="form.sex"
                  placeholder="请选择性别"
                  clearable
                >
                  <el-option :value="2" label="男" />
                  <el-option :value="1" label="女" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号码" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入手机号码"
                  clearable
                />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="民族" prop="nationality">
                <el-input
                  v-model="form.nationality"
                  placeholder="请输入民族"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签发机关" prop="issuingAuthority">
                <el-input
                  v-model="form.issuingAuthority"
                  placeholder="请输入签发机关"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="住址" prop="address">
                <el-input
                  autosize
                  type="textarea"
                  v-model="form.address"
                  placeholder="请输入住址"
                  clearable
                  maxlength="90"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="公民身份证号码" prop="identificationNumber">
                <el-input
                  v-model="form.identificationNumber"
                  placeholder="请输入公民身份证号码"
                  clearable
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="身份证有效期" prop="idCardDueDate">
                <el-date-picker
                  v-model="form.idCardDueDate"
                  :class="form.hasDueDate ? 'disabledhide' : ''"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="长期" label-width="60px">
                <el-checkbox
                  v-model="form.hasDueDate"
                  @change="
                    value => {
                      this.$set(
                        form,
                        'idCardDueDate',
                        value ? '9999-12-31' : ''
                      );
                    }
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传证件">
                <ImgReview
                  lebal="实际承运人身份证人像面照片"
                  :src="form.identificationImg"
                  error="未上传"
                  v-if="parentData.isDetail"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '实际承运人身份证人像面照片',
                    prefix: 'identification',
                    form: form,
                    suffix: 'Img'
                  }"
                  :parent-data="form"
                  :required="!!form.identificationImg"
                  v-else
                />
                <ImgReview
                  lebal="实际承运人身份证国徽面照片"
                  :src="form.identificationBackImg"
                  error="未上传"
                  v-if="parentData.isDetail"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '实际承运人身份证国徽面照片',
                    prefix: 'identificationBack',
                    form: form,
                    suffix: 'Img'
                  }"
                  :parent-data="form"
                  :required="!!form.identificationBackImg"
                  v-else
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="mode_box" :class="{ pitch_on: !!form.driverIsup }">
          <div class="card_info">其他证件信息</div>
          <div class="card_type_title">机动车驾驶证</div>
          <el-row style="padding-right:80px;">
            <el-col :span="8">
              <el-form-item label="驾驶证号" prop="driverLicense">
                <el-input
                  v-model="form.driverLicense"
                  placeholder="请输入机动车驾驶证号"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="档案编号" prop="fileNo">
                <el-input
                  v-model="form.fileNo"
                  placeholder="请输入档案编号"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发证机关" prop="driverIssuingOrganizations">
                <el-input
                  v-model="form.driverIssuingOrganizations"
                  placeholder="请输入机动车驾驶证发证机关"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="准驾类型" prop="vehicleClass">
                <el-select
                  v-model="form.vehicleClass"
                  placeholder="请选择准驾类型"
                  clearable
                >
                  <el-option
                    v-for="item in parentData.vehicleTypeAllowList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="有效期自" prop="driverLicenseFromDate">
                <el-date-picker
                  v-model="form.driverLicenseFromDate"
                  type="date"
                  placeholder="请选择机动车驾驶证有效期开始日期"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="初次领证日期" prop="firstIssueDate">
                <el-date-picker
                  v-model="form.firstIssueDate"
                  type="date"
                  placeholder="请输入机动车驾驶证初次领证日期"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="有效期至" prop="driverLicenseDueDate">
                <el-date-picker
                  v-model="form.driverLicenseDueDate"
                  :class="form.hasDriverDueDate ? 'disabledhide' : ''"
                  type="date"
                  placeholder="请选择机动车驾驶证有效期结束日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  :disabled="form.hasDriverDueDate"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="长期" label-width="60px">
                <el-checkbox
                  v-model="form.hasDriverDueDate"
                  @change="
                    value => {
                      this.$set(
                        form,
                        'driverLicenseDueDate',
                        value ? '9999-12-31' : ''
                      );
                    }
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传证件">
                <ImgReview
                  lebal="机动车驾驶证照片"
                  :src="form.driverLicenseImg"
                  error="未上传"
                  v-if="parentData.isDetail"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '机动车驾驶证照片',
                    prefix: 'driverLicense',
                    form: form,
                    suffix: 'Img'
                  }"
                  :parent-data="form"
                  :required="!!form.driverLicenseImg"
                  v-else
                />
                <ImgReview
                  lebal="机动车驾驶证副页照片"
                  :src="form.driverLicenseBackImg"
                  error="未上传"
                  v-if="parentData.isDetail"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '机动车驾驶证副页照片',
                    prefix: 'driverLicenseBack',
                    form: form,
                    suffix: 'Img'
                  }"
                  :parent-data="form"
                  :required="!!form.driverLicenseBackImg"
                  v-else
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card_type_title" style="margin-top:15px;">
            道路运输从业资格证
          </div>
          <el-row style="padding-right:80px;">
            <el-col :span="13">
              <el-form-item label="资格证号" prop="workLicense">
                <template slot="label">
                  资格证号
                </template>
                <el-input
                  v-model="form.workLicense"
                  placeholder="请输入道路运输从业资格证号"
                  clearable
                />
                <div class="remarks">
                  注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="资格类别" prop="qualificationCategory">
                <el-input
                  v-model="form.qualificationCategory"
                  placeholder="请输入道路运输从业资格证从业资格类别"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item
                label="初次领证日期"
                prop="initialCertificationDate"
              >
                <el-date-picker
                  v-model="form.initialCertificationDate"
                  type="date"
                  placeholder="初次领证日期"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="到期日期" prop="workLicenseDueDate">
                <el-date-picker
                  v-model="form.workLicenseDueDate"
                  type="date"
                  placeholder="请选择道路运输从业资格证到期日期"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传证件">
                <ImgReview
                  lebal="道路运输从业资格证照片"
                  :src="form.workLicenseImg"
                  error="未上传"
                  v-if="parentData.isDetail"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '道路运输从业资格证照片',
                    prefix: 'workLicense',
                    form: form,
                    suffix: 'Img'
                  }"
                  :parent-data="form"
                  :required="!!form.workLicenseImg"
                  v-else
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div :class="{ pitch_on: !!form.roadIsup }"></div>
      </el-form>
    </div>
    <br />
    <br />
    <el-dialog
      title="驳回意见"
      :visible.sync="showRefuse"
      append-to-body
      modal-append-to-body
      width="600px"
      class="clearfix"
    >
      <el-form ref="formData" :model="form">
        <el-form-item prop="authMsg">
          <el-input
            v-model="authMsg"
            placeholder="请输入驳回意见"
            type="textarea"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4 }"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="clearfix">
        <el-button @click="funcRefuse" type="primary" style="float: right;"
          >确认驳回</el-button
        >
      </div>
    </el-dialog>
    <!-- -->
  </div>
</template>
<script>
import {
  isTaxOpen,
  authInfo,
  driverAuth,
  updateDriverTeam
} from "@/api/driver.js";
import ImgReview from "@/components/ImgReview";
import ImgUpload from "@/components/ImgUpload";
import request from "@/utils/request";
import { insuranceType } from "@/api/orderform";
export default {
  name: "DriverEdit",
  components: {
    ImgReview,
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          mode: "detail"
        };
      }
    },
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      rules: {
        identificationNumber: [
          { required: true, message: "请输入公民身份证号码", trigger: "blur" }
        ],
        idCardDueDate: [
          { required: true, message: "请选择身份证有效期", trigger: "change" }
        ],
        driverLicense: [
          { required: true, message: "请输入驾驶证号", trigger: "blur" }
        ],
        fileNo: [
          { required: true, message: "请输入档案编号", trigger: "blur" }
        ],
        vehicleClass: [
          { required: true, message: "请选择准驾类型", trigger: "change" }
        ],
        driverLicenseDueDate: [
          { required: true, message: "请选择有效期至", trigger: "change" }
        ],
        workLicense: [
          { required: true, message: "请输入资格证号", trigger: "blur" }
        ],
        qualificationCategory: [
          { required: true, message: "请输入从业资格类别", trigger: "blur" }
        ],
        workLicenseDueDate: [
          { required: true, message: "请选择到期日期", trigger: "change" }
        ]
      },
      showRefuse: false, //驳回意见弹窗
      showExtra: true,
      ctmsShow: true,
      hasTaxOpen: "",
      authMsg: "",
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      reportProvinceName: "",
      code: "",
      form: {
        isHasTrailer: 0,
        birthDate: "", //  出生年月
        gender: "", //性别
        phone手机号码: "", //
        nationality: "", //民族
        issuingAuthority: "", //签发机关
        address: "", //住址
        idCard: "" //公民身份证号码
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }]
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    review() {
      return this.parentData.model === "review" ? true : false;
    }
  },
  watch: {},
  created() {
    this.reportProvinceName = this.reportProvince();
    this.form = {
      vehicleVO: {}
    };
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
  },
  methods: {
    ficationImgSuccess(e) {
      console.log("实际承运人身份证人像面照片", e);
    },
    setisDetail() {
      this.parentData.isDetail = !this.parentData.isDetail;
    },
    getDriver(code) {
      this.code = code;
      authInfo({ code: code }).then(response => {
        console.log("response", response);
        let vehicleVO = response.data.vehicleVO || {};
        this.form = Object.assign({}, response.data, vehicleVO);

        this.authMsg = response.data.authMsg || "";
        this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
      });
      // request({
      //   url: `/ntocc-basic-api/driver/${code}`,
      //   method: "get",
      // }).then((response) => {
      //   let vehicleVO = response.data.vehicleVO || {};
      //   this.form = Object.assign({}, response.data, vehicleVO);
      //   this.authMsg = response.data.authMsg || "";
      //   this.$set(this.form, "areaList", []);
      //   if (
      //     this.form.provinceCode &&
      //     this.form.cityCode &&
      //     this.form.countyCode
      //   ) {
      //     this.form.areaList.push(
      //       this.form.provinceCode,
      //       this.form.cityCode,
      //       this.form.countyCode
      //     );
      //   }
      //   this.$set(
      //     this.form,
      //     "hasDueDate",
      //     this.form.idCardDueDate == "9999-12-31"
      //   );
      //   this.$set(
      //     this.form,
      //     "hasDriverDueDate",
      //     this.form.driverLicenseDueDate == "9999-12-31"
      //   );
      // });
      insuranceType(this.instype).then(response => {
        this.locationSourceoptions = response.data.records;
      });
    },
    // 同意审核
    funcSubmit() {
      const rLoading = this.openLoading();
      driverAuth({ code: this.code, authStatus: 3 }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
      // request({
      //   url: `/ntocc-basic-api/driver/updateAuthStatus`,
      //   method: "post",
      //   params: {
      //     code: this.code,
      //     authStatus: 3,
      //   },
      // })
    },
    submitEdit() {
      updateDriverTeam(this.form).then(response => {
        this.$message({
          message: "编辑成功",
          type: "success"
        });
        this.setisDetail();
      });
    },
    changeShowRefuse() {
      this.showRefuse = true;
    },
    // 拒绝审核
    funcRefuse() {
      if (this.authMsg.trim() == "") {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const rLoading = this.openLoading();
      driverAuth({
        code: this.code,
        authStatus: 2,
        authMsg: this.authMsg
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
      // request({
      //   url: `/ntocc-basic-api/driver/updateAuthStatus`,
      //   method: "post",
      //   params: {

      //   },
      // })
    }
  }
};
</script>
<style lang="scss" scoped>
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  margin-top: 45px;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}

._btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 30px;
  .reject {
    width: 160px;
    height: 46px;
    background: #ef4141;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    margin-right: 16px;
  }
  .adopt {
    width: 160px;
    height: 46px;
    background: #4186ef;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
  }
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
.pitch_on {
  border: 1px solid #ff2c2c;
  padding: 6px 12px;
  box-sizing: border-box;
  margin: 12px 0;
}
.edit_box {
  position: relative;
  .edit_button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9;
  }
}
.form_wrap {
  padding-left: 30px;
  padding-right: 30px;
}
.line1 {
  width: 100%;
  height: 45px;
  border-bottom: 2px solid #1169e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .line1_left {
    width: 171px;
    height: 45px;
    line-height: 45px;
    background-image: url("~@/assets/tms/detail.png");
    background-size: 171px 45px;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    padding-left: 54px;
  }
  .line1_right {
    width: 99px;
    height: 36px;
    background: #1169e9;
    border-radius: 3px 3px 3px 3px;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.card_type_title {
  font-size: 19px;
  font-weight: bold;
  margin-left: 30px;
  margin-bottom: 20px;
}
::v-deep .el-tooltip__popper.is-dark {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
/* eslint-enable no-console */
